import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'
import DataRestoreKeys from 'src/constants/locale/key/DataRestore'
import moment from 'moment'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {

  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  let errMsgNumeric = translate(
    Namespace.DATA_RESTORE,
    DataRestoreKeys.Validations.ERROR_MSG_NUMERIC
  )

  let errMsgMaxValue = translate(
    Namespace.DATA_RESTORE,
    DataRestoreKeys.Validations.ERROR_MSG_MAX_VALUE
  )

  let errDataRestoreDateRange = translate(
    Namespace.DATA_RESTORE,
    DataRestoreKeys.Validations.ERROR_DATA_RESTORE_DATE_RANGE
  )

  
  let errDateFromLesserThanDateTo = translate(
    Namespace.DATA_RESTORE,
    DataRestoreKeys.Validations.ERROR_DATE_FROM_LESSER_THAN_DATE_TO
  )

  
  let errDateToGreaterThanDateFrom = translate(
    Namespace.DATA_RESTORE,
    DataRestoreKeys.Validations.ERROR_DATE_TO_GREATER_THAN_DATE_FROM
  )

  return Yup.object({
    module: Yup.string().nullable().required(requiredMessage),
    type: Yup.string().nullable().required(requiredMessage),
    restoreBy: Yup.string().nullable().required(requiredMessage),
    searchCriteria: Yup.string().when('restoreBy', {
      is: (value) => value !== 'DATE_RANGE',
      then: Yup.string().required(requiredMessage),
    }).nullable(),
    searchCriteria2: Yup.string().when('restoreBy', {
      is: (value) => value === 'AM_KEY' || value === 'MANIFEST_KEY' || value === 'BL_NUMBER',
      then: Yup.string().required(requiredMessage),
      otherwise: Yup.string()
    }).nullable(),
    searchCriteria3: Yup.string().when('restoreBy', {
      is: (value) => value === 'MANIFEST_KEY',
      then: Yup.string().required(requiredMessage),
      otherwise: Yup.string()
    }).nullable(),
    searchCriteria4: Yup.string().when('restoreBy', {
      is: (value) => value === 'MANIFEST_KEY',
      then: Yup.string().required(requiredMessage),
      otherwise: Yup.string()
    }).nullable(),
    searchCriteria5: Yup.string().when('restoreBy', {
      is: (value) => value === 'MANIFEST_KEY',
      then: Yup.string().required(requiredMessage),
      otherwise: Yup.string()
    }).nullable(),
    dateFrom: Yup.string().nullable().when('restoreBy', {
      is: (value) => value === 'DATE_RANGE',
      then: Yup.string().required(requiredMessage).test(
        'dateFrom',
        dateTypeErrorMessage,
        value => {
          return moment(value, 'YYYY-MM-DD').isValid()
        }
      )
      .when(['dateTo','dateFrom'], (dateTo,dateFrom) => {
            if (dateTo) {
              return Yup.string().test("dateTo", errDateFromLesserThanDateTo, (value) => {
                return new Date(dateTo) >= new Date(dateFrom);
              })
            }
            return Yup.string()
          }
        )
      ,
      otherwise: Yup.string().nullable()
    }).nullable(),
    dateTo: Yup.string().nullable().when('restoreBy', {
      is: (value) => value === 'DATE_RANGE',
      then: Yup.string().required(requiredMessage).test(
        'dateTo',
        dateTypeErrorMessage,
        value => {
          return moment(value, 'YYYY-MM-DD').isValid()
        }
      )
      .when(
        ['dateFrom','dateTo'],
          (dateFrom, dateTo) => {
          if(dateFrom){
              const maRetentionDay = 60;
              const nextDay = new Date(new Date(dateFrom).getTime() + 86400000*maRetentionDay);
              return Yup.string().test("dateFrom", errDateToGreaterThanDateFrom, (value) => {
                return new Date(dateTo) >= new Date(dateFrom);
              }).test("dateFrom", errDataRestoreDateRange, (value) => {
                return nextDay >= new Date(dateTo);
              })
            }
            return Yup.string()
          }
        )
      ,
      otherwise: Yup.string().nullable()
    }).nullable(),
    dayToRetain: Yup.number().typeError(errMsgNumeric).max(30,errMsgMaxValue+" 30").nullable().required(requiredMessage),
    userId: Yup.string().nullable().required(requiredMessage)
  })
}

export default makeValidationSchema
